import { useState, useEffect } from 'react'

import API from '../../../../api/api'
import { parseEventsForCalendar } from '../../../../helpers/helpers'

export const useGetEventById = (eventId) => {
  const [event, setEvent] = useState(null)
  const [isLoading, setIsLoading] = useState(!!eventId)
  const [isError, setIsError] = useState(false)

  const fetchEvent = async () => {
    try {
      setIsLoading(true)
      setIsError(false)
      const response = await API.getEventById(eventId)
      const parsedEvent = parseEventsForCalendar([response.data])
      setEvent(parsedEvent[0])
    } catch (error) {
      console.log(error)
      setIsError(true)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    if (!eventId) return
    fetchEvent()
  }, [eventId])

  return { event, isLoading, isError }
}
